// ./src/components/features/CreateEventWizard/data/eventTypeGroups.ts
//
// How the type picker PRESENTS the five category groups — label, one-liner, icon, accent colour. Presentation only.
//
// ⚠⚠ THE TYPES THEMSELVES ARE NOT HERE ANY MORE (ROADMAP A2b #62, 2026-09-29). This file used to be a hand-kept mirror
// of the server seed — 33 types with emojis and a "may not repeat" list — which could not show the 14 sub-types and
// had drifted from the seed. Every type, emoji, synonym and "may repeat" flag now comes from the ONE catalog,
// `eventSetupCatalog` (hooks/useEventSetupCatalog). Do not add types here; add them to the API seed catalog
// (`src/database/seeds/catalog/eventTypes.js`).

/** The five top-level groups the picker organizes occasions under. */
export const EVENT_CATEGORY_GROUP = {
  CELEBRATION: 'celebration',
  MILESTONE: 'milestone',
  PROFESSIONAL: 'professional',
  COMMUNITY: 'community',
  OTHER: 'other',
} as const;

export type EventCategoryGroup = (typeof EVENT_CATEGORY_GROUP)[keyof typeof EVENT_CATEGORY_GROUP];


export interface EventTypeGroupMeta {
  group: EventCategoryGroup;
  /** Section heading. */
  label: string;
  /** One-line description of the group. */
  description: string;
  /** AppIcon name for the section header. */
  icon: string;
  /** Brand color token for the group accent. */
  color: string;
}

const { CELEBRATION, MILESTONE, PROFESSIONAL, COMMUNITY, OTHER } = EVENT_CATEGORY_GROUP;

/** Group headers, in display order. */
export const EVENT_TYPE_GROUPS: EventTypeGroupMeta[] = [
  {
    group: CELEBRATION,
    label: 'Celebrations',
    description: 'Parties and get-togethers',
    icon: 'Confetti',
    color: 'grape',
  },
  {
    group: MILESTONE,
    label: 'Milestones',
    description: 'Life’s big moments',
    icon: 'Sparkles',
    color: 'coral',
  },
  {
    group: PROFESSIONAL,
    label: 'Professional',
    description: 'Business and work events',
    icon: 'Briefcase',
    // NOTE: use REGISTERED theme color keys only. `periwinkle`/`ink` are palette
    // tuples mapped onto `blue`/`gray` in the theme — they are NOT own keys, so
    // `--mantine-color-periwinkle-6` doesn't resolve and the selected border
    // disappears. `blue` renders the same periwinkle hue.
    color: 'blue',
  },
  {
    group: COMMUNITY,
    label: 'Community',
    description: 'Groups, causes and gatherings',
    icon: 'Users',
    color: 'jade',
  },
  {
    group: OTHER,
    label: 'Something else',
    description: 'Start from scratch',
    icon: 'Dots',
    // `gray` maps to the ink palette (see note above).
    color: 'gray',
  },
];
